import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useEffect } from 'react';
import { AccountInformation } from './AccountInformation';
const Account = () => {
    const dispatch = useAppDispatch();
    const { shufftiProRedirectData } = useAppSelector((state) => state.shufftiPro);
    useEffect(() => {
        if (shufftiProRedirectData) {
            window.location.href = shufftiProRedirectData.verificationUrl;
        }
    }, [dispatch, shufftiProRedirectData]);
    return (_jsx(_Fragment, { children: _jsx(AccountInformation, {}) }));
};
export default Account;
